<template>
  <div class="themeBody" :data-theme="themeMode">
    <go-back-button :is-align-center="true" v-if="$store.state.isInSlicer == true"
                    class="policiesGoBackButton">
      <template v-slot:body>
        隐私政策
      </template>
    </go-back-button>

    <div style="text-align: left" v-html="articleContent"></div>
  </div>
</template>

<script>
import {articleDetail} from "@/api/api";

export default {
  data() {
    return {
      // articleContent: "",//接口获取的文章html代码
      articleTitle: `<h1>隐私政策</h1>`,
      articleContent: "",
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  created() {
    // 后期更新了服务器上的接口html 再使用请求获取
    // this.getPrivacy()
    if (this.$store.state.isInSlicer == true) {
      this.articleTitle = ``
    }
    this.articleContent=`
<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>隐私政策</title>
</head>

<style data-emotion="portal-css-global hcq6pi">
    html {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        box-sizing: border-box;
        -webkit-text-size-adjust: 100%;
    }

    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }

    strong{
        font-size: 22px;
        font-weight: 700;
    }

    b {
        font-weight: 700;
    }

    body {
        margin: 0;
        color: #212B36;
        line-height: 1.5;
        font-size: 1.6rem;
        font-family: "Open Sans", "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans;
        font-weight: 400;
        background-color: #ffffff;
    }

    @media print {
        body {
            background-color: #fff;
        }
    }

    body::backdrop {
        background-color: #EEEEEE;
    }

    body {
        font-size: 16px;
    }
</style>

<style>
    .article-css {
        max-width: 800px;
        margin: 0 auto;
        padding: 0 20px;
        overflow: hidden;
    }

    .article-css a {
        color: #2196f4;
    }

    .article-css p,
    .article-css ol,
    .article-css ul {
        padding-bottom: 15px;
        color: #757575;
    }

    .article-css h1 {
        font-size: 22px;
    }

    strong {
        color: #000000;
    }
</style>

<body>
    <div class="">
        <div class="article-css">
            <h1>隐私政策</h1>
            <p><strong>概要</strong></p>
            <p>QIDI Link及其关联实体(包括浙江起迪科技有限公司及其子公司，以下简称“QIDI Link”或“我们”)高度重视您的隐私。我们特此制定《隐私政策》(以下简称“本政策”)，告知您我们如何收集、使用、披露、保护、存储和传输您的个人数据。
            </p>
            <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
            <p>电子邮件: <a href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>，或寄信至：</p>
            <ul>
                <li>中国浙江省温州市瑞安市安阳街道罗阳大道吾悦广场806号2号楼，邮编：325200。</li>
            </ul>
            <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息。本政策解释了QIDI Link如何处理您的个人信息。本政策适用于QIDI Link所有产品和服务。
            </p>
            <p>最后更新时间：2024 年 1 月 20 日。</p>
            <p>本政策将帮助您了解以下内容：</p>
            <ol style="list-style-type:decimal;">
                <li>我们如何收集和使用您的个人信息</li>
                <li>我们如何使用 Cookie 和同类技术</li>
                <li>我们如何使用 SDK</li>
                <li>我们如何共享、转让、公开披露您的个人信息</li>
                <li>我们如何保护您的个人信息</li>
                <li>您对您的个人信息享有的权利</li>
                <li>我们如何处理未成年人的个人信息</li>
                <li>您的个人信息如何在全球范围转移</li>
                <li>您的个人信息存储期限</li>
                <li>本政策如何更新</li>
                <li>如何联系我们</li>
            </ol>
            <p><strong>一、我们如何收集和使用您的个人信息</strong></p>
            <p><strong>（一）我们如何收集您的个人信息</strong></p>
            <p>当您使用我们的产品和服务时，您可能需要提供个人信息。虽然并非强制向我们提供个人信息，但在某些情况下，如果您选择不提供，我们可能无法向您提供相关产品或服务或处理和解决您遇到的问题。我们只会出于本政策中概述的目的收集和使用您的个人信息。以下示例说明了我们可能收集的个人信息类型：
            </p>
            <ul>
                <li>账户信息：当您创建QIDI Link账户时，您可能会提供个人信息，包括您的用户名/电话号码、电子邮件地址、密码或其他用于账户安全设置的相关信息。您可以选择在个人资料页面上提供其他信息，例如性别、生日、职业和其他详细信息。当您使用第三方账户注册/登录时，我们可能会获取您的头像、昵称等公开信息以及您授权的其他信息。
                </li>
                <li>联系信息：当您向QIDI Link下订单或寻求客户服务时，您可能向我们提供联系信息，包括您的姓名、别名、电子邮件地址、送货地址和联系电话。</li>
                <li>支付信息：当您购买QIDI Link产品和服务或与QIDI Link进行金融交易时，您可以选择使用第三方支付机构(包括微信支付、支付宝、银联，统称“支付机构”)提供的支付服务。虽然支付功能本身不会收集您的个人信息，但我们需要与这些支付机构共享您的订单号和交易金额信息，以确认您的支付指令并完成交易。
                </li>
                <li>照片、视频和文件：未经您明确同意和采取行动，QIDI Link不会自动收集您的照片、视频和文件内容。当您在使用QIDI Link产品和服务时上传照片、视频或其他文件内容时，我们可能会收集和存储此类内容，包括与照片或视频相关的
                    EXIF 数据。如果该等内容包含第三方信息，您在将该等内容上传至QIDI Link之前，应获得第三方必要或适当的同意，并告知其本隐私政策。</li>
                <li>打印任务信息：
                    <ul>
                        <li>当您将打印机配置为纯 LAN 模式并启动打印任务时。</li>
                        <li>当您使用 USB 闪存驱动器上存储的模型启动打印任务时。</li>
                        <li>当您使用打印机内置存储器上存储的模型启动打印任务时。</li>
                    </ul>
                </li>
                <li>通讯数据：当您联系我们时，我们可能会收集有关您的通讯信息，包括您的联系方式以及通讯时间、主题和内容。</li>
                <li>地点信息：当您激活QIDI Link硬件产品或使用我们的应用程序时，您可能向我们提供位置相关信息。为了向我们提供您的位置，您可能需要启用设备的某些功能(例如 Wi-Fi 和蓝牙)，以通过各种方式(包括 IP
                    地址、移动应用程序列表信息、移动信号塔位置或物理位置)识别您的位置。检测现场 Wi-Fi
                    或蓝牙传感器)。如果您的位置是通过您的移动设备的Wi-Fi或蓝牙或其他非Qidi产品收集的，请注意，此类传感器和相关数据服务可能由第三方提供。第三方可能会访问此类信息，以便向QIDI Link提供数据服务。您可以向第三方导航软件服务提供商提供您的位置信息，以接收QIDI Link产品的位置服务。
                </li>
                <li>设备相关信息：当您激活 Qidi 产品并请求售后服务时，您可以向我们提供有关您 Qidi
                    设备的信息，包括型号和序列号。为了向您提供售后服务，我们的售后服务团队可能会向您请求设备数据。当您向QIDI Link产品发送命令时，我们会收集并使用您提供的信息。
                </li>
                <li>技术信息：当您访问我们的网站或使用我们的移动应用程序时，您可能会向我们提供有关设备的技术信息，例如设备上运行的浏览器或应用程序。这些信息包括您的 IP
                    地址或设备地址、浏览器和/或设备类型/序列号、您在使用产品或服务之前或之后访问的网页或网站、硬件版本和操作系统。我们还可能使用该技术收集有关您与QIDI Link电子邮件交互的信息，例如您是否打开、点击或转发上述消息。
                </li>
                <li>诊断信息：我们收集有关您的Qidi产品和设备的操作信息，例如其设置、功能、性能、设备操作条件、日志文件/日志信息、设备活动、错误报告以及系统或应用程序崩溃时的内存状态。
                </li>
                <li>职位申请信息：当您申请QIDI Link职位时，您可以向我们提供您的教育信息，例如您的学历和毕业学校，以及与就业相关的信息，例如您以前的雇主和工作成就。我们还可能从第三方招聘人员或网站收集此类信息。</li>
                <li>自动数据收集：当您浏览我们的网站并进行互动时，我们可能会使用自动数据收集技术来收集有关您的设备、浏览行为和模式的某些信息。这包括您访问我们网站的详细信息和其他通信数据、您保存和使用的网站，以及有关您的计算机和互联网连接的信息，包括您的
                    IP 地址、操作系统和浏览器类型。自动收集的信息为统计数据，不包含个人信息。</li>
                <li>传感器信息：当您播放视频等内容时，我们可能会调用设备的传感器(例如重力和加速度传感器)来适应您设备的方向。</li>
                <li>设备权限：当您在设备上安装我们的应用程序时，可能会请求某些设备权限以支持相关功能和服务。对于可以关闭的权限，用户可以通过所使用设备的设置功能单独禁用:<ul>
                        <li>电话权限：<ul>
                                <li>权限名称：电话</li>
                                <li>用途：用于应用程序的安全运行和风控验证，以及内容推送通知。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                        <li>存储/相册权限：<ul>
                                <li>权限名称：存储</li>
                                <li>用途：用于上传/更新账户头像以及评论文本/视频内容。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                        <li>相机权限：<ul>
                                <li>权限名称：相机</li>
                                <li>用途：用于设置或更新头像、相册管理、图片保存、录像、扫描二维码等。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                        <li>位置权限：<ul>
                                <li>权限名称：位置</li>
                                <li>用途：用于发布更新时的定位功能以及智能设备网络配置。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                        <li>通知栏权限：<ul>
                                <li>权限名称：通知</li>
                                <li>用途：用于推送应用相关消息。</li>
                                <li>可以禁用：可以，禁用会阻止实时内容更新和阅读，影响应用的正常使用。</li>
                            </ul>
                        </li>
                        <li>互联网权限：<ul>
                                <li>权限名称：互联网</li>
                                <li>用途：实现互联网访问功能和设备网络配置。</li>
                                <li>可以禁用：可以，禁用会阻止内容实时更新和阅读，影响应用的正常使用。</li>
                            </ul>
                        </li>
                        <li>蓝牙权限：<ul>
                                <li>权限名称：蓝牙</li>
                                <li>用途：用于蓝牙设备网络配置。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                        <li>修改/删除 SD 卡中的内容权限：<ul>
                                <li>权限名称：修改/删除 SD 卡中的内容</li>
                                <li>用途：用于下载存储使用教程的压缩包和解压操作。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                        <li>允许应用获取手机号，IMEL IMSI权限：<ul>
                                <li>权限名称：允许应用获取手机号，IMEL IMSI </li>
                                <li>用途：我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。</li>
                                <li>可以禁用：可以，禁用只会影响相应功能，不会影响其他应用功能。</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>为保证在使用QIDI Link APP服务时与后端服务器实时通信并及时收到相关内容推送通知，我们可能：<ul>
                        <li>利用QIDI Link APP的启动广播(自启动)能力，保证APP关闭或后台运行时也能收到客户端推送消息。这就需要通过系统以一定的频率发送广播来唤醒QIDI Link APP进行自启动或联动启动，这是实现特定功能和服务所必需的。</li>
                        <li>利用第三方推送通知服务为您的设备生成唯一标识符，以区分其唯一性。</li>
                        <li><strong>读取手机状态判断QIDI Link APP处于前台还是后台，提高推送服务的及时性。</strong></li>
                    </ul>
                </li>
            </ul>
            <p><strong>（二）我们如何使用您的个人信息</strong></p>
            <p>我们会将您的个人信息用于以下目的：</p>
            <ol style="list-style-type:decimal;">
                <li>运营和提供QIDI Link产品及服务功能。验证和管理Qidi用户帐户，提供您要求的服务和信息，处理并交付与QIDI Link定期提供的促销活动相关的参赛作品和奖励。根据本隐私政策以及通过 Qidi 产品和服务(包括 Qidi
                    应用程序)表达的任何偏好进行处理。
                </li>
                <li>了解使用趋势和偏好：分析使用趋势和偏好。完善QIDI Link产品和服务。开发新产品、服务、特性和功能。</li>
                <li>出于管理和信息提供目的而联系：出于管理目的和信息提供(包括客户服务)的目的与您联系。发送与我们以及与我们合作的第三方提供的产品和服务相关的直接营销信息，包括促销和活动更新。对于个人或消费者，我们只会在您同意或在法律限制范围内发送直接营销信息。您可以随时取消订阅或撤回您的同意。有关更多信息，请参阅第六节“您对个人信息的权利”。
                </li>
                <li>欺诈检测、预防和响应：检测、预防和应对可能损害我们的用户、我们或公众的欺诈、滥用权力、安全风险和技术问题。问题解决、更正和升级。</li>
                <li>解决问题、纠正和升级，以提高QIDI Link产品和服务的性能。</li>
                <li>其他目的：将您的信息用于在收集信息时向您披露的或经您事先同意的任何其他目的。</li>
                <li>我们将汇总我们收集的个人数据，例如您访问我们网站和应用程序的频率和次数，以生成指标和统计信息。我们使用汇总数据来帮助我们了解网站的使用情况，提高其可用性，并提高我们提供的产品和服务的质量和可用性。
                </li>
                <li>遵守适用法律。</li>
            </ol>
            <p><strong>（三）在下列情况下，未经您的授权，我们有权收集、使用您的个人信息：</strong></p>
            <ol style="list-style-type:decimal;">
                <li>与国家安全和国防相关：涉及国家安全和国防。</li>
                <li>与公共安全、公共卫生、重大公共利益相关的：涉及公共安全、公共卫生、重大公共利益的。</li>
                <li>与刑事侦查、起诉、审判、判决执行有关的：与刑事侦查、起诉、审判和判决执行有关。</li>
                <li>当难以获得同意时保护重大合法利益：为保护信息主体或其他个人的重大合法利益所必需，但获得信息主体同意较困难。</li>
                <li>数据主体自愿披露：所收集的个人信息由数据主体自愿向公众披露。</li>
                <li>从合法公开披露的信息收集：从合法公开披露的信息中收集，例如合法的新闻报道、政府信息公开等。</li>
                <li>应您的要求签订合同所需的材料：根据您的要求签订合同所必需的。</li>
                <li>产品和/或服务安全稳定运行所必需的：为所提供的产品和/或服务的安全、稳定运行所必需的，例如发现和处理产品和/或服务的故障。</li>
                <li>合法新闻报道所需：合法新闻报道所必需的。</li>
                <li>公共利益学术研究的必要性：学术研究机构为公共利益进行学术研究所必需的。对外提供学术研究或描述的结果时，将对其中包含的个人信息进行去标识化处理。</li>
            </ol>

            <p>您的个人信息中可能包含您的种族、宗教、个人健康状况、性取向等敏感信息。您在使用我们的产品或服务时，可能会通过公共渠道上传或发布此类敏感信息。请谨慎处理此类敏感个人信息。
            </p>
            <p>当我们拟将信息用于本政策未载明的用途时，我们会事先征求您的同意。当我们拟将特定目的收集的信息用于其他目的时，会事先征求您的同意。</p>
            <p>当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>

            <p><strong>二、我们如何使用Cookie 和类似技术</strong></p>
            <p>我们的网站、移动应用软件、在线服务、电子邮件和广告可能会使用 cookie、像素标签和网络信标以及其他本地存储技术。通过 cookie 和类似技术收集的信息被视为非个人信息。但是，如果当地法律将 IP
                地址或类似标识符视为个人信息，我们也会将此类标识符视为个人信息。</p>
            <p><strong>（一）Cookie</strong></p>
            <p>Cookie 是网络服务器存储在计算机或移动设备上的文本文件。 cookie 的内容只能由创建它的服务器检索或读取。每个 cookie 对于您的网络浏览器或移动应用程序来说都是唯一的。 Cookie
                通常包含标识符、站点名称以及一些数字和字符。</p>
            <p>我们有时会在计算机或移动设备上存储 cookie 以改善用户体验，包括：</p>
            <ol style="list-style-type:decimal;">
                <li>登录和身份验证：使用cookie，您可以在登录后从网站上的一个页面导航到另一个页面，而无需在每个页面上登录。</li>
                <li>存储首选项和设置：网站可以使用 cookie 来保存语言、字体大小、购物车以及计算机或移动设备上的其他浏览首选项等设置。</li>
                <li>基于兴趣的广告：我们使用 cookie 收集有关您在线活动的信息、发现您的兴趣并为您提供最相关的广告。</li>
                <li>统计分析：通过 Cookie，我们可以收集有关您使用我们网站和其他应用程序的信息，例如记录单次访问(使用会话 Cookie)或多次访问(使用持久 Cookie)。</li>
                <li>我们不会将 cookie 用于本声明所述目的以外的目的。您可以根据您的喜好管理或删除cookie。大多数网络浏览器都具有阻止 cookie
                    的功能。有关如何更改浏览器设置的详细信息，请参阅浏览器的“帮助”文件以了解修改 cookie 设置的正确方法。</li>
                <li>如果您清除 cookie，则每次访问我们的网站时都需要手动更改用户设置。请注意，我们的某些服务可能需要使用 cookie，禁用 cookie 可能会影响这些服务的部分或全部功能。</li>
            </ol>
            <p><strong>（二）网络信标/像素标签</strong></p>
            <p>除了 Cookie 之外，我们和一些第三方还在网站上使用网络信标或像素标签。网络信标通常是嵌入网站或电子邮件中的电子图像，可用于在您查看网页或电子邮件时识别设备上的 cookie。像素标签使我们能够以您可以阅读的格式发送电子邮件，并使我们能够知道电子邮件是否已被打开。</p>
            <p>                我们和一些第三方将此类技术用于各种目的，包括分析服务使用情况(与 cookie 结合使用)以及提供更适合您需求的内容和广告。例如，我们向您发送的电子邮件可能包含链接到我们网站内容的点击 URL。如果您点击此类链接，我们会跟踪该点击，以帮助我们了解您的产品和服务偏好并改善客户服务。如果您不希望您的活动以这种方式被跟踪，您可以随时从我们的电子邮件列表中退订。</p>

            <p><strong>（三）其他本地存储</strong></p>
            <p>我们和一些第三方可能会在某些产品和服务中使用其他本地存储技术，例如本地共享对象(通常称为 Flash cookies)和 HTML5 本地存储。与上面提到的 cookie 类似，这些技术存储在您的设备上，可用于记录有关您的活动和偏好的某些信息。但是，这些技术可能与用于标准 cookie 的设备不同，因此您可能无法使用标准浏览器工具和设置来控制它们。有关禁用或删除 Flash cookie 中包含的信息的说明，请单击此处。</p>

            <p><strong>（四）请勿追踪</strong></p>
            <p>许多网络浏览器都具有“请勿跟踪”选项，可向网站发送“请勿跟踪”请求。目前，主要互联网标准组织尚未制定政策来规范网站应如何响应此类请求。</p>
            <p>我们不会根据您选择的“请勿跟踪”设置或其他“选择退出”设置或您的浏览器可能提供的功能来更改本文档中详细说明的数据收集和使用实践。但是，我们保留将来更改数据处理方法的权利，恕不另行通知。
            </p>
            <p><strong>三、我们如何使用 SDK</strong></p>
            <p>为了提供和优化我们的服务，我们的应用程序可能会嵌入第三方 SDK。虽然这些第三方 SDK 帮助我们为您提供更全面的服务，但它们可能会收集您的个人信息。我们将采取必要措施控制这些第三方SDK对您个人信息的收集和使用，确保您的个人信息得到有效保护。有关第三方身份、收集目的以及第三方隐私政策链接的信息，请参阅附录1：第三方SDK信息。
            </p>
            <p><strong>四、我们如何共享、转让和公开披露您的个人信息</strong></p>
            <p><strong>（一）共享</strong></p>
            <p>我们不会与QIDI以外的任何公司、组织和个人共享您的个人信息。</p>
            <p><strong>（二）转让</strong></p>
            <p>转让是指将个人信息的控制权从我们转移到另一个数据控制者的过程。我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
            <ol>
                <li>明确同意的转让：在您明确同意的情况下，我们会将您的个人信息转让给其他方。
                </li>
                <li>如果发生涉及个人信息转让的合并、收购或破产清算，我们将要求新的持有您个人信息的公司或组织继续受本隐私政策的约束。否则，我们将要求新的公司或组织再次征求您的授权。
                </li>
            </ol>
            <p><strong>（三）公开披露</strong></p>
            <p>我们仅在以下情况下才会公开披露您的个人信息：</p>
            <ol>
                <li>个人同意：经您明确同意。</li>
                <li>法律披露：在法律要求、法律程序、诉讼或政府当局的强制要求的情况下，我们可能会公开披露您的个人信息。</li>
            </ol>
            <p><strong>五、我们如何保护您的个人信息。</strong></p>
            <p>我们优先考虑个人信息的安全，并实施行业标准实践来保护您的个人信息，防止未经授权的访问、披露、使用、修改、损坏或丢失。为此，我们采取了以下措施：</p>
            <ol style="list-style-type:decimal;">
                <li>我们采取一切合理可行的措施，确保最大限度地减少个人信息的收集，避免为实现既定目的而收集无关的个人信息。我们只会在实现本声明中概述的目的所需的必要期限内保留您的个人信息，除非法律要求或允许延期。</li>
                <li>我们采用加密技术、去标识化技术等安全措施确保数据传输和存储的机密性。采用可信保护机制来防止对数据和存储数据的服务器的恶意攻击。</li>
                <li>部署访问控制机制以确保只有授权人员才能访问个人信息。根据业务需求和人员层级控制访问授权，分级权限由管理员管理并定期审核。</li>
                <li>我们开展与安全和隐私保护相关的培训、测试和宣传活动，增强员工对保护个人信息重要性的认识。</li>
            </ol>
            <p>虽然我们努力确保您发送给我们的任何信息的安全，但值得注意的是，互联网环境并不完全安全。如果我们的物理、技术或管理保障措施遭到破坏，导致信息被未经授权的访问、披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。若不幸发生个人信息安全事件，我们将按照法律要求，通过合理、有效的方式(包括公告)及时通知您。此外，我们还将按照要求积极向监管部门报告个人信息安全事件的处理情况。
            </p>
            <p><strong>六、您对您的个人信息享有的权利</strong></p>
            <p><strong>根据中国法律、法规、标准以及其他国家和地区的通行做法，我们确保您就您的个人信息行使以下权利：

            </strong></p>
            <p><strong>（一）访问和更正您的个人信息</strong></p>
            <p>您有权按照法律规定查阅、更正您的个人信息。如果您想行使您的数据访问权，您可以访问以下内容：</p>
            <p>帐户信息：如果您希望访问或编辑个人资料信息、付款详细信息、更改密码、添加安全信息或关闭帐户，您可以通过访问我们的网站或应用程序上的相关页面来执行此类操作。但出于安全和身份验证的原因或根据法律法规的要求，您可能无法修改注册时提供的初始注册信息。
            </p>
            <p>如果您无法通过上述方式访问或更正这些个人信息，您可以发送电子邮件至<a href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>，或通过网站或应用程序提供的方式联系我们。
            </p>
            <p><strong>（二）删除您的个人信息</strong></p>
            <p>在以下情况下，您可以请求我们删除个人信息：</p>
            <ol style="list-style-type:decimal;">
                <li>处理目的已经实现、不再能够实现或者不再需要实现处理目的。</li>
                <li>我们停止提供产品或服务，或者保留期已过期。</li>
                <li>您按照本节第 (3) 款的规定撤回您的同意。</li>
                <li>我们收集和使用个人信息违反法律法规。</li>
                <li>我们对个人信息的处理违反了与您之间的协议。我们将评估您的请求，并根据适用法规采取相应措施，包括必要时的技术措施。请注意，由于法律和技术限制，我们可能无法立即从备份系统中删除相应的信息。在这种情况下，我们将安全地存储您的个人信息，并将其与任何进一步处理隔离，直到可以清除备份或匿名化。</li>
            </ol>
            <p><strong>（三）撤回同意</strong></p>
            <ol>
                <li>一般情况</li>
            </ol>
            <p>对于一般情况，您可以撤回之前为特定目的(包括收集、使用和/或披露您的个人信息)而授予我们的同意。根据您使用的具体服务，您可以随时发送电子邮件至<a
                    href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>联系我们进行相关操作。我们将在您提出请求后的合理时间内处理您的请求，并根据您的请求，停止收集、使用和/或披露您的个人信息。
            </p>
            <p>根据您撤回同意的范围，可能会影响您继续享受我们的产品或服务。但您撤回同意或授权，并不影响我们此前基于您的同意进行的个人信息处理活动的有效性。

            </p>
            <p>如果您不希望接收我们的自动化决策，包括通过信息系统、算法等向您发送的信息推送和营销信息，您可以随时通过我们的电子邮件或短信中提供的方式退订。</p>
            <p><strong>（四）数据主体删除账户</strong></p>
            <p>您可以随时发送电子邮件至<a href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>停用您之前注册的帐户。。
            </p>
            <p>我们将在15个工作日内完成账户停用。停用您的帐户后，我们将停止向您提供产品或服务。我们将根据您的要求删除您的个人信息，法律法规另有规定的除外。</p>
            <p><strong>（五）对您的请求的回应</strong></p>
            <p>为了确保安全，您可能需要提供书面请求或其他方式证明您的身份。在处理您的请求之前，我们可能会要求您验证您的身份。</p>
            <p>如果您不满意，还可以向网信办、电信监管机构、公安、工商等监管部门投诉或举报。</p>
            <p>对于合理的请求，我们一般不收取任何费用。但对于重复提出、超出合理限度或超出实际可行范围的请求(例如涉及过多技术手段的请求，如开发新系统或从根本上改变现行做法)，可能对合法权益构成风险和他人利益或非常不切实际的(例如，涉及备份磁带上存储的信息)，我们可能会拒绝满足此类请求，并可能收取一定的成本费。</p>
            <p>在以下情况下，我们将无法按照法律法规的要求回应您的请求：。</p>
            <ol style="list-style-type:decimal;">
                <li>直接关系国家安全和国防安全。</li>
                <li>直接关系公共安全、公共卫生和重大公共利益。</li>
                <li>与刑事侦查、起诉、审判和判决执行直接相关。</li>
                <li>有充分证据表明您存在主观恶意或滥用权利。</li>
                <li>响应您的请求将会对您或其他个人、组织的合法权益造成严重损害。</li>
                <li>直接关系到您或其他个人的生命、财产等的保护，但很难获得您的个人授权。</li>
                <li>涉及商业秘密。</li>
                <li>与我们履行法律法规规定的法律义务有关。</li>
            </ol>
            <p><strong>七、我们如何处理未成年人的个人信息</strong></p>
            <p>我们认为，监督未成年人使用我们的产品或服务是父母或监护人的责任。但我们不直接向未成年人提供服务，也不将未成年人的个人信息用于营销目的。任何 14 岁以下的人都被视为未成年人。</p>
            <p>如果我们发现我们在未事先获得可验证的父母同意的情况下收集了未成年人的个人信息，或者如果您是父母或监护人并认为未成年人已向我们提交了个人信息，您可以发送电子邮件至<a
                    href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>请随时联系我们，以确保立即删除此类个人信息，并取消未成年人对任何适用的 QIDI 服务的订阅。
            </p>
            <p><strong>八、您的个人信息如何在全球范围内转移</strong></p>
            <p>我们会将在中华人民共和国境内运营期间收集和产生的个人信息存储在位于中国大陆的数据中心，除非适用的跨境传输法律另有允许。</p>
            <p><strong>九、您的个人信息的存储期限</strong></p>
            <p><strong>（一）一般情况</strong></p>
            <p>一般情况下，我们会在实现您授权的使用目的所需的最短期限内保留您的个人信息，除非法律法规另有规定或获得您的单独授权或同意。上述个人信息保存期限过后，我们将删除或匿名化您的个人信息。
            </p>
            <p><strong>（二）特别协议</strong></p>
            <p>我们不会存储您的任何打印信息，所有信息将直接记录在您的打印机上。未经许可，我们不会连接到您的打印机。
            </p>
            <p><strong>十、本政策如何更新</strong></p>
            <p>我们将根据业务和技术的变化定期审查隐私政策，并可能更新本隐私政策。如果本隐私政策发生重大变更，我们将通过移动应用内的弹窗通知您，以便您了解我们收集的信息以及我们如何使用这些信息。
            </p>
            <p>此类隐私政策变更将从通知或网站上指定的生效日期起生效。我们建议您定期查看此页面，了解有关我们隐私惯例的最新信息。您继续使用QIDI的产品和服务，将被视为接受更新后的隐私政策。当我们向您收集更多的个人信息或出于新的目的使用、披露您的个人信息时，我们将再次征求您的同意。
            </p>
            <p><strong>十一、如何与我们联系</strong></p>
            <p>如果您对本隐私政策有任何疑问，评论或建议，则可以将电子邮件发送至<a href="mailto:info@qd3dprinter.com">info@qd3dprinter.com</a>，或邮寄至：</p>
            <ul>
                <li>浙江起迪科技有限公司</li>
                <li>中国浙江省温州市瑞安市安阳街道罗阳大道吾悦广场806号2号楼，邮编：325200。</li>
            </ul>
            <p>信息保护负责人电话：0086-577-66881077。</p>
            <p>如果您对我们的回应不满意，特别是我们对个人信息的处理损害了您的合法权益，您也可以向网信办、电信监管机构、公安、工商等监管部门投诉或举报。</p>
            <p style="margin-left:0px;">&nbsp;</p>
        </div>
    </div>
</body>

</html>
      `

  },
  methods: {
    getPrivacy() {
      let params = {
        type: "2",
        lang: 'zh'
      }
      articleDetail(params).then(res => {
        console.log(res)
        if (res.status === 0) {
          this.articleContent = res.data.content;
          console.log('this.articleContent', this.articleContent);
          //this.$notify.success({
          //   title: this.$t('h.common.tip'),
          //   message: "获取隐私政策成功",
          // });
        } else {
          //this.$notify.error({
          //   title: this.$t('h.common.tip'),
          //   message: "获取隐私政策错误",
          // });
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

>>> .article-css{
  @include background_color('background_color');
  @include font_color('text-color');
}

>>> strong{
  @include font_color('text-color');
}

</style>



// WEBPACK FOOTER //
// src/views/policies/privacy.vue